/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBarber } from "../../entities/models/Barber";
import { z } from "zod/v4";

export const modelsBarberSchema = z.object({
    "branch_id": z.optional(z.int()),
"can_cut_children": z.optional(z.boolean()),
"created_at": z.optional(z.string()),
"id": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"name": z.optional(z.string()),
"phone": z.optional(z.string()),
"photo_url": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBarber>